<template>
  <div>
    <div v-if="isEditor">
      <h5 style="padding-bottom: 6px;">
        {{ label }}
        <span class="uk-text-regular uk-text-small">
          <br>
          <a @click="onSelect(true)">
            {{ $t('static_translation.alle-auswaehlen') }}
          </a>
          &nbsp;|&nbsp;
          <a @click="onSelect(false)">
            {{ $t('static_translation.alle-abwaehlen') }}
          </a>
        </span>
      </h5>
      <CheckboxGroup
        v-model="myValue"
        @on-change="emitValue">
        <Checkbox
          v-for="item in items"
          :key="parseInt(item.id)"
          :label="parseInt(item.id)"
          style="width:165px;"
          class="tw-ellipsis"
        >
          <span
            v-if="translate"
            style="font-size:13px;padding-top: 1px;"
          >
            &nbsp;{{ $t(name + '.' + item.id) }}
          </span>
          <span
            v-else
            style="font-size:13px;padding-top: 1px;"
          >
            &nbsp;{{ item.name }}
          </span>
        </Checkbox>
      </CheckboxGroup>

    </div>
    <div v-else>
      <dl
        v-if="displayValue"
        class="uk-description-list">
        <dt>{{ label }}</dt>
        <dd>
          {{ displayValue }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { strings, booleans, arrays } from '@/mixins/props/defaults'

export default {
  mixins: [
    strings('label', 'name'),
    booleans('!isEditor', '!translate'),
    arrays('items')
  ],
  props: {
    value: {
      type: [Array, Object],
      default: () => {}
    }
  },
  data () {
    return {
      myValue: []
    }
  },
  computed: {
    displayValue () {
      const values = []
      _.forEach(this.value, o => {
        const object = _.find(this.items, { id: o })
        if (object) values.push(object)
      })
      const names = _.map(values, o => {
        return o.name
      })
      return names.join(', ')
    }
  },
  mounted () {
    let value = this.value
    if (!_.isArray(value)) {
      value = _.toArray(value)
    }
    this.myValue = value
  },
  methods: {
    emitValue () {
      this.$store.commit('updateInquiry', { name: this.name, value: this.myValue })
    },
    onSelect (value) {
      const values = (value) ? this.items.map(item => item.id) : []
      this.$store.commit('updateInquiry', {
        name: this.name,
        value: values
      })
      this.myValue = values
      return true
    }
  }
}
</script>
